import { Component, Ref } from "vue-property-decorator";
import Template from "@/components/BaseCurd/template";
import dayjs from "dayjs";
import "./index.less";
import {
  ProductRegisterServiceProxy,
  ConsoleGatewayServiceProxy,
  IothubServiceProxy,
} from "@/service-proxies/app-v2/console.service-proxies";
import { MasterlinkTenantServiceProxy } from "@/service-proxies/app-v2/system.service-proxies";
import CurdForm from "@/components/BaseCurd/form";
import { getUserInfo } from '@/utils/auth'
import { RecordRemarkDTO } from "@/service-proxies/app-v2/coproduction.service-proxies";

const systemService = new MasterlinkTenantServiceProxy();
const gatewayService = new ConsoleGatewayServiceProxy();
const iothubService = new IothubServiceProxy();
const service = new ProductRegisterServiceProxy();
enum Codes {
  硬件网关 = 1,
  软件网关 = 3,
}

type test = [];

@Component({
  CurdForm,
})
export default class Batch extends Template {
  @Ref() readonly form: CurdForm;

  name = "batch";
  templateModalClass = "batch-modal2";
  scroll = {
    x: 1600,
  };

  options = {
    retrieve: async function(current: any, filter: any, size: any) {
      const tenantId = getUserInfo().tenant_id
      return await service.page(current, filter, size, this.selectTenant || tenantId);
    },
    create: (data) => {
      const {
        productType,
        tenantId,
        allowConnectionCount,
        productName,
        productCode,
        iothubId,
        totalNumber,
        remark,
      } = data;

      return service.add(
        allowConnectionCount,
        iothubId,
        productCode,
        productName,
        productType,
        remark,
        tenantId,
        totalNumber
      );
    },
    update: (data) => {
      const {
        batchNo,
        productType,
        tenantId,
        allowConnectionCount,
        productName,
        productCode,
        iothubId,
        totalNumber,
        remark,
      } = data;
      return service.update(
        allowConnectionCount,
        batchNo,
        iothubId,
        productCode,
        productName,
        productType,
        remark,
        tenantId,
        totalNumber
      );
    },
    delete: service.delete.bind(service),
  };
  get lang() {
    return {
      placeholder: this.$t("keyword"),
      search: this.$t("search"),
      create: this.$t("page_batch_management_create"),
      delete: this.$t("delete"),
    };
  }
  acl = {
    create: "page_batch_management_create",
    update: "page_batch_management_update",
    delete: "page_batch_management_delete",
    register: "page_batch_management_register",
  };
  showRegisterDialog = false;
  registerdataValue = {};
  hidden = ["delete"];
  tenants = [];
  selectTenant = undefined;

  async mounted() {
    const {
      data: { records },
    } = await systemService.getTenants(undefined, 1, -1, undefined, undefined);

    this.tenants = records;
  }

  handleChange() {
    this.getData();
  }

  get columns() {
    return [
      {
        title: this.$t("page_batch_management_action"),
        key: "action",
        // fixed: "left",
        width: 200,
        customRender: (row,record) => {
          return (
            record.id &&
            <div style="">
              <a
                type="link"
                onClick={(e) => {
                  e.stopPropagation();
                  this.openEditWindow(row);
                }}
              >
                {this.$t("edit")}
              </a>
              <a-divider type="vertical" />
              <a
                type="link"
                disabled={!this.getAcl(this.acl.register)}
                onClick={(e) => {
                  e.stopPropagation();
                  this.openRegisterDialog(row);
                }}
              >
                {this.$t("page_batch_management_register_equipment")}
              </a>
              <a-divider type="vertical" />
              <a-popconfirm
                disabled={!this.getAcl(this.acl.delete)}
                title={this.$t("page_resource_pool_confirm_delete")}
                onConfirm={() => this.deleteSingleData(row.batchNo)}
                okText={this.$t("yes")}
                cancelText={this.$t("no")}
              >
                <a
                  type="link"
                  disabled={!this.getAcl(this.acl.delete)}
                  onClick={(e) => e.stopPropagation()}
                  class="del-color"
                >
                  {this.$t("delete")}
                </a>
              </a-popconfirm>
            </div>
          );
        },
      },
      {
        title: this.$t("page_batch_management_no"),
        dataIndex: "batchNo",
        key: "batchNo",
        width: 98,
      },
      {
        title: this.$t("page_batch_management_description"),
        dataIndex: "remark",
        key: "remark",
        width: 205,
        customRender: (text) => (
          <ellipsis length={20} tooltip>
            {text}
          </ellipsis>
        ),
      },
      {
        title: this.$t("page_batch_management_type"),
        dataIndex: "productType",
        key: "productType",
        width: 123,
        customRender: (text) => Codes[text],
      },
      {
        title: this.$t("page_batch_management_name"),
        dataIndex: "productName",
        key: "productName",
        width: 123,
      },
      {
        title: this.$t("page_batch_management_code"),
        dataIndex: "productCode",
        key: "productCode",
        width: 123,
      },
      {
        title: this.$t("page_batch_management_number"),
        dataIndex: "totalNumber",
        key: "totalNumber",
        width: 123,
      },
      {
        title: this.$t("page_batch_management_auth_apps"),
        dataIndex: "allowConnectionCount",
        key: "allowConnectionCount",
        width: 156,
      },
      {
        title: this.$t("page_batch_management_iothub"),
        // dataIndex: "iothubAddress",
        key: "iothubAddress",
        width: 200,
        customRender: (row,record) => {
          if(record.id) {
            return `${row.iothubGatewayPort}`
          }
        }
      },
      {
        title: this.$t("page_batch_management_key"),
        dataIndex: "activateKey",
        key: "activateKey",
        width: 136,
      },
      {
        title: this.$t("page_batch_management_counder"),
        dataIndex: "createUserName",
        key: "createUserName",
        width: 133,
      },
      {
        title: this.$t("page_batch_management_createtime"),
        dataIndex: "createTime",
        key: "createTime",
        width: 203,
        customRender: (time,record) => {
          if(record.id) {
            return dayjs(time).format("YYYY-MM-DD HH:mm:ss")
          }
        },
      },
    ];
  }

  get schema() {
    return {
      productType: {
        label: this.$t("page_batch_management_type"),
        type: "radio",
        props: {
          placeholder: this.$t("page_batch_management_type_tips"),
        },
        options: [
          {
            label: this.$t("page_batch_management_Hardware"),
            value: 1,
          },
          {
            label: this.$t("page_batch_management_Software"),
            value: 3,
          },
        ],
        rules: [
          {
            required: true,
            message: this.$t("page_batch_management_type_tips"),
          },
        ],
        disabled: true,
      },
      tenantId: {
        label: this.$t("page_batch_management_tenant"),
        type: "select",
        props: {
          placeholder: this.$t("page_batch_management_tenant_tips"),
        },
        rules: [
          {
            required: true,
            message: this.$t("page_batch_management_tenant_tips"),
          },
        ],
        disabled: true,
        options: async () => {
          const { data } = await systemService.getTenants(
            undefined,
            1,
            -1,
            undefined,
            undefined
          );
          const { records } = data;
          return records.map((r) => ({
            label: r.tenantName,
            value: r.tenantId,
          }));
        },
      },
      allowConnectionCount: {
        label: this.$t("page_batch_management_auth_apps"),
        type: "inputNumber",
        rules: [
          {
            required: true,
            message: this.$t("page_batch_management_auth_apps_tips"),
          },
        ],
        props: {
          min: 1,
        },
        disabled: true,
      },
      productName: {
        label: this.$t("page_batch_management_name"),
        type: "input",
        props: {
          maxLength: 32,
          placeholder: this.$t("page_batch_management_name_tips"),
        },
        rules: [
          {
            required: true,
            message: this.$t("page_batch_management_name_tips"),
          },
        ],
        disabled: true,
      },
      productCode: {
        label: this.$t("page_batch_management_code"),
        type: "input",
        props: {
          maxLength: 32,
          placeholder: this.$t("page_batch_management_code_tips"),
        },
        rules: [
          {
            required: true,
            message: this.$t("page_batch_management_code_tips"),
          },
        ],
        disabled: true,
      },
      iothubId: {
        label: this.$t("page_batch_management_iothub"),
        type: "select",
        props: {
          placeholder: this.$t("page_batch_management_iothub_tips"),
        },
        rules: [
          {
            required: true,
            message: this.$t("page_batch_management_iothub_tips"),
          },
        ],
        options: async () => {
          const data = await iothubService.query();
          return data.map((r) => ({
            label: `${r.gatewayPort}`,
            value: r.id,
          }));
        },
        disabled: true,
      },
      totalNumber: {
        label: this.$t("page_batch_management_number"),
        type: "inputNumber",
        props: {
          min: 1,
        },
        rules: [
          {
            required: true,
            message: this.$t("page_batch_management_number_tips"),
          },
        ],
        disabled: true,
      },
      remark: {
        label: this.$t("page_batch_management_description"),
        type: "textarea",
        props: {
          placeholder: this.$t("page_batch_management_description_tips"),
          maxLength: 255,
        },
      },
    };
  }

  get registerSchema() {
    return {
      batchNo: {
        label: this.$t("page_batch_management_register_batch"),
        type: "input",
        disabled: true,
        props: {
          placeholder: this.$t("page_batch_management_register_batch_tips"),
        },
        rules: [
          {
            required: true,
            message: this.$t("page_batch_management_register_batch_tips"),
          },
        ],
      },
      activateCount: {
        label: this.$t("page_batch_management_activation_number"),
        type: "inputNumber",
        props: {
          min: 1,
        },
        rules: [
          {
            required: true,
            message: this.$t("page_batch_management_activation_number_tips"),
          },
        ],
      },
      name: {
        label: this.$t("remark"),
        type: "textarea",
        props: {
          placeholder: this.$t("remark_tips"),
          maxLength: 255,
        },
      },
    };
  }

  render() {
    const slot = (
      <div style="display: flex;align-items:center">
        {getUserInfo().tenant_id === '000000' ?
        (<div style="display: flex;align-items:center">
          <span style="width:40px">{this.$t("page_tenant")}:</span>
          <a-select
            placeholder={this.$t("page_tenant")}
            style="width:250px;margin-right:12px"
            allowClear
            v-model={this.selectTenant}
            onChange={this.handleChange}
          >
            {this.tenants.map((item) => {
              return (
                <a-select-option key={item.id} value={item.tenantId}>
                  {item.tenantName}
                </a-select-option>
              );
            })}
          </a-select>
        </div>): ''}

        <span style="width:60px">{this.$t("keyword")}:</span>
      </div>
    );

    return (
      <blank-view class="batch-wrapper">
        {this.renderHeader(slot)}
        <div style="height:100%">
          {this.renderBody()}
          {this.renderDialog()}
          {this.renderDrawer()}
        </div>
        <a-modal
          class="batch-modal"
          onCancel={() => (this.showRegisterDialog = false)}
          title={this.$t("page_batch_management_register_equipment")}
          visible={this.showRegisterDialog}
          destroyOnClose={true}
          maskClosable={false}
        >
          <div slot="footer">
            <a-button
              style="margin-right:8px"
              onClick={() => (this.showRegisterDialog = false)}
            >
              {this.$t("cancel")}
            </a-button>
            <a-button type="primary" onClick={this.registerData}>
              {this.$t("save")}
            </a-button>
          </div>
          <CurdForm
            acl={{
              save: this.acl.register,
            }}
            ref="form"
            type="edit"
            schema={this.registerSchema}
            defaultValue={this.registerdataValue}
            footer={false}
          />
        </a-modal>
      </blank-view>
    );
  }

  openRegisterDialog(row) {
    this.registerdataValue = row;
    this.showRegisterDialog = true;
  }

  async registerData() {
    const data: any = await this.form.manualSubmit();
    const { activateCount, batchNo, name } = data;
    await gatewayService.add(activateCount, batchNo, name);
    this.$message.success(this.$t("page_docdirectory_create_success"));
    this.showRegisterDialog = false;
  }
}
